<div class="modal-head">
  <h1 mat-dialog-title class="mb-0">{{ "MUSIC_INFO.SHARE" | translate }}</h1>
  <a href="javascript:void(0)" mat-button (click)="close()">
    <span class="mdi mdi-close"></span>
  </a>
</div>
<hr />
<div class="modal-body" mat-dialog-content>
  <div class="text-center px-4">
    <div class="mx-auto mb-3" style="width: 145px">
      <div class="ratio-slider ratio-1-1">
        <img src="{{ data?.thumbnails | thumbnails: 'square' }}" />
      </div>
    </div>
    <figcaption class="o-flag__body pl-3">
      <h5>{{ data.name }}</h5>
      <p class="mb-0">
        <a
          class="text-secondary"
          *ngFor="let cast of data.cast_and_crew; let i = index"
        >
          <span>{{ cast.name | titlecase }}</span>
          <span *ngIf="data.cast_and_crew.length !== i + 1">,&nbsp;</span>
        </a>
      </p>
    </figcaption>
  </div>
  <div class="share-icons px-4 pt-4">
    <div class="icons-social">
      <share-button
        class="social-btn"
        [size]="10"
        button="facebook"
        url="{{ appConstant.shareUrl + 'music-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <share-button
        [size]="10"
        button="twitter"
        url="{{ appConstant.shareUrl + 'music-detail/' + data.public_id }}"
        (click)="onBlurEvent()"
      >
      </share-button>
      <share-button
      [size]="10"
      button="email"
      url="{{ appConstant.shareUrl + 'music-detail/' + data.public_id }}"
      (click)="onBlurEvent()"
    >
    </share-button>
    </div>
  </div>
</div>

<!-- <div class="px-4" mat-dialog-actions>
    <div>
        <a href="javascript:void(0)" class="chat_dedi text-secondary d-flex align-items-center mb-3">
            <svg width="18" height="18" viewBox="0 0 18 18" class="mr-2">
                <g fill="none" fill-rule="evenodd">
                    <path d="M.72 0H18v17.28H.72z"></path>
                    <path class="fill_path"
                        d="M8.639 15.84h-5.55l.957-1.03a.72.72 0 0 0 .015-.963c-.773-.887-1.182-1.94-1.182-3.047 0-2.778 2.584-5.04 5.76-5.04.244 0 .483.017.72.044v-1.45a7.932 7.932 0 0 0-.72-.034c-3.97 0-7.2 2.907-7.2 6.48 0 1.25.39 2.442 1.132 3.482L.911 16.07a.72.72 0 0 0 .528 1.21h7.2c3.97 0 7.2-2.907 7.2-6.48h-1.44c0 2.78-2.585 5.04-5.76 5.04z">
                    </path>
                    <path class="fill_path"
                        d="M17.279 2.88A2.883 2.883 0 0 0 14.399 0a2.883 2.883 0 0 0-2.88 2.88.72.72 0 0 0-.72.72v5.04c0 .398.322.72.72.72h5.76a.72.72 0 0 0 .72-.72V3.6a.72.72 0 0 0-.72-.72zm-2.88-1.44c.794 0 1.44.645 1.44 1.44h-2.88c0-.795.645-1.44 1.44-1.44zm2.16 6.48h-4.32v-3.6h4.32v3.6z">
                    </path>
                    <ellipse cx="14.399" cy="5.76" class="fill_path" rx=".72" ry=".72"></ellipse>
                </g>
            </svg>
            Share privately
        </a>
        <a href="javascript:void(0)" class="text-secondary d-flex align-items-center">
            <span class="mdi mdi-link-variant font-18 mr-2"></span> CopyLink
        </a>
    </div>
</div> -->
